var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadge2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02719 17H14.9772V15.404H11.0292L13.2132 12.996C14.1932 11.918 14.8512 11.022 14.8512 9.776C14.8512 8.236 13.5492 7.032 12.0092 7.032C10.3572 7.032 9.33519 8.04 8.99919 9.37L10.6232 9.888C10.7492 9.174 11.1692 8.642 11.9252 8.642C12.5972 8.642 13.1432 9.188 13.1432 9.86C13.1432 10.574 12.6952 11.148 11.8412 12.142L9.02719 15.432V17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge2);
export default __webpack_public_path__ + "static/media/Badge 2.f2e69b8dfa058d1d2f6ce24743513500.svg";
export { ForwardRef as ReactComponent };